// difference is part of the ES spec but not supported by all our target browsers
// I don't think it's worth pulling in a polyfill for one method but if we do
// polyfill in the future, we should delete this and use the polyfill version
export function difference<T>(setX: Set<T>, setY: Set<T>): Set<T> {
  const result = new Set<T>(setX);
  for (const item of setY) {
    result.delete(item);
  }
  return result;
}
